import React from 'react';
import ReactDOM from 'react-dom';
import '@/config/locales';
import App from './App';


ReactDOM.render(
  <App />,
  document.getElementById('root')
);
